<mat-card
    class="full-height mat-main-card"
    [class.mat-card-raised]="isActive">
    <mat-progress-bar mode="indeterminate" class="card-top" [class.hidden]="!isLoading"></mat-progress-bar>
    
    <mat-card-title>
        <span class="primary">Use cases</span>
        
        <mat-form-field class="search-bar" *ngIf="!isEmpty && model">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput
                [(ngModel)]="currentSearch"
                placeholder="Search"
                (keyup)="searchPreview( $event, searchInput )"
                #searchInput
            />
                <!-- [matAutocomplete]="auto" -->
            <!-- <mat-autocomplete #auto (optionSelected)="autocompleteSelected( $event, searchInput )">
              <mat-option *ngFor="let item of autocompleteList" [value]="item">
                {{item}}
              </mat-option>
            </mat-autocomplete> -->
        </mat-form-field>
    </mat-card-title>

    <!-- on empty list -->
    <mat-card-content *ngIf="useCasesError">
        <div class="h4">Something went wrong...</div>
        <span>{{ useCasesError }}</span>
    </mat-card-content>

    <mat-card-content *ngIf="isEmpty">
        <div style="text-align: center;">
            <mat-icon svgIcon="use_cases_empty" class="use-cases-empty"></mat-icon>
        </div>
        <div class="h4">This section is empty</div>
        <div class="h6">Start creating rules and rulesets</div>
    </mat-card-content>

    <mat-card-content *ngIf="!isEmpty && model" class="main-content" style="padding: 0;">
        <span>This window will show all the current Use Cases.</span>

        <!-- filter - temporaly disabled -->
        <!-- <mat-card-actions fxFlexAlign="end" align="end" class="filter-actions">
            <button mat-button [matMenuTriggerFor]="filter" class="link">
                <mat-icon>tune</mat-icon> Filter
            </button>
            <mat-menu #filter [overlapTrigger]="false">
                <button mat-menu-item (click)="this.filterUseCases('all'); showFilterMessage=null;">All types</button>
                <button mat-menu-item (click)="this.filterUseCases('active'); showFilterMessage='active';">View active use cases</button>
                <button mat-menu-item (click)="this.filterUseCases('disabled'); showFilterMessage='disabled';">View disabled use cases</button>
            </mat-menu>
        </mat-card-actions> -->

        <mat-card-content> <!--style="padding: 0;"-->
            <mat-list *ngIf="showFilterMessage">
                <mat-list-item class="title">
                    <span class="text">{{ showFilterMessage==='active' ? 'ACTIVE': 'DISABLED' }} USE CASES</span>
                    <button mat-icon-button (click)="this.filterUseCases('all'); showFilterMessage=null;" matTooltip="Remove filter">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-list-item>
            </mat-list>

            <div *ngIf="searchChips.length">
                <mat-chip-list #chipList>
                    <span>Search results for:&nbsp;</span>
                    <mat-chip
                        *ngFor="let chip of searchChips"
                        (removed)="removeChip(chip)"
                        (click)="removeChip(chip)"
                    >
                        {{ chip }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>
            <div *ngIf="useCasesFull.length && useCasesFiltered.length === 0" class="no-results-filter">
                <div style="text-align: center;">
                    <mat-icon svgIcon="dead_end" class="dead-end"></mat-icon>
                </div>
                <div class="h4">No matching use cases found.</div>
                <div class="h6">Please make sure your keywords are spelled correctly.</div>
                <a (click)="clearSearch()" color="primary" class="link">Reset search</a>
            </div>
            <!-- main list -->
            <card-list [(model)]="useCasesFiltered"
                (onEdit)="onEdit( $event )"
                (onDelete)="onDelete( $event )"
                [sortAlphabetically]="true"
                [selectedIndex]="selectedUseCaseIndex"
                showVersions="true"
                (onDebug)="onDebug( $event )" showDebug="true"
                (onVersions)="onVersions( $event.record, $event.date, $event.versionDates )"
                sortBy="Name"
                [highlightWords]="searchList"
            >
            </card-list>
        </mat-card-content>
    </mat-card-content>

    <!-- footer -->
    <mat-card-actions *ngIf="!isLoading" fxFlexAlign="end" align="end">
        <mat-divider></mat-divider>
        <!-- <button mat-raised-button
            color="primary"
            class="toolbar-bottom-button"
            (click)="onUseCaseGenerator()"
        > UC Generator</button> -->
        <button mat-raised-button
            color="primary"
            class="toolbar-bottom-button"
            (click)="this.getUseCases()"
        >{{ (useCasesError ? 'Try again' : 'Refresh') }}</button>

        <button mat-raised-button *ngIf="!useCasesError"
            color="primary"
            class="toolbar-bottom-button"
            (click)="onCreate()"
            >Add use case</button>
    </mat-card-actions>
</mat-card>